import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { selector: String };

  connect() {
    const header = document.querySelector(this.selectorValue);
    if (!header) return;

    this.updateTop = () => {
      this.element.style.top = `${header.offsetHeight}px`;
    };
    this.updateTop();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', this.updateTop);
      return;
    }

    this.observer = new ResizeObserver(this.updateTop);
    this.observer.observe(header);
  }

  disconnect() {
    this.observer?.disconnect();
    if (this.updateTop) window.removeEventListener('resize', this.updateTop);
  }
}
